import { createSlice } from "@reduxjs/toolkit";

export const SearchFiltersSlice = createSlice({
  name: "SearchFilters",
  initialState: {
    isSearchFiltersAvailable: false,
    data: {
      fromYear: 0,
      toYear: 0,
      weightCode: "",
      fromHeight: 0,
      toHeight: 0,
      fitnessCode: "",
      beliefTypeCodes: [],
      politicalOrientationCodes: [],
      clothingTypeCodes: [],
      livingCityPriorityOneId: 0,
      livingCityPriorityTwoId: 0,
      livingCityPriorityThreeId: 0,
      residenceAbroadTypeCode: "",
      branchFilter: 3,
      spouseEconomicMatterCodes: [],
      spouseWorkingMatterCodes: [],
      spouseFamilyInOtherCityAllowed: false,
      spouseMilitaryAllowed: false,
      spouseSpiritualAllowed: false,
      spouseEthnicityMatter: false,
      spouseEthnicityCode: undefined,
      spousePersonalityCode: "27003",
      associateDegreeAllowed: false,
      bachelorDegreeAllowed: false,
      masterDegreeAllowed: false,
      phDDegreeAllowed: false,
      seminaryDegreeAllowed: false,
      educationDoesNotMatter: false,
      engineeringEducationGroup: false,
      medicalEducationGroup: false,
      humanitiesEducationGroup: false,
      artEducationGroup: false,
      seminaryEducationGroup: false,
      otherEducationGroup: false,
      educationGroupDoesNotMatter: false,
      educationDescription: "",
      spouseSingle: false,
      spouseUnsuccessfulContract: false,
      spouseDivorced: false,
      spouseMartyr: false,
      spouseDeceased: false,
      haveChildrenAllowed: false,
      childGenderMatter: false,
      childrenCountMatter: false,
      childrenAgeMatter: false,
      marriageDescription: "",
      spouseNotSmoker: false,
      hookahAllowed: false,
      spouseMustBeAthlete: false,
      spouseMustBeArtist: false,
    },
  },
  reducers: {
    changeSearchFiltersAvailability: (state, { payload }) => {
      state.isSearchFiltersAvailable = payload;
    },
    updateSearchFiltersData: (state, { payload: { key, value, required } }) => {
      state.data[key] = value;
      if (value.length === 0) {
        if (required) {
          state.data[key] = value;
        } else {
          delete state.data[key];
        }
      } else {
        state.data[key] = value;
      }
    },
    setSearchFiltersData: (state, { payload }) => {
      state.data = payload;
    },
    updateArrayFieldSearchFiltersData: (state, { payload: { key, value, code, reset } }) => {
      let codes = [];
      if (state.data[key]) {
        codes = [...state.data[key]];
      }
      if (!reset)
        if (value) {
          codes.push(code);
        } else {
          codes = codes.filter((item) => item !== code);
        }
      state.data[key] = reset ? [] : codes;
    },
  },
});

export const {
  changeSearchFiltersAvailability,
  setSearchFiltersData,
  updateSearchFiltersData,
  updateArrayFieldSearchFiltersData,
} = SearchFiltersSlice.actions;

export const SearchFiltersReducer = SearchFiltersSlice.reducer;
